import {
  IUserCategoryBase,
  IUserCategoryHikcentralOrganizationBase,
} from '../../models/userCategories';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface ICreateUsercategoriesProps {
  orgIndexCode: string | null;
  maxDayBookings?: number;
  maxFreeGuestDayBookings?: number;
  maxGuestDayBookings?: number;
  title: string;
  ventureId: string;
}

export interface INewUserCategory extends IUserCategoryBase {
  hikcentralOrganization: IUserCategoryHikcentralOrganizationBase;
}

export const createUserCategoriesService = async ({
  orgIndexCode,
  maxDayBookings,
  maxFreeGuestDayBookings,
  maxGuestDayBookings,
  title,
  ventureId,
}: ICreateUsercategoriesProps): Promise<INewUserCategory> => {
  const { data } = await jhsfBookingsApi.post<INewUserCategory>(
    '/user-categories',
    {
      orgIndexCode,
      maxDayBookings,
      maxFreeGuestDayBookings,
      maxGuestDayBookings,
      title,
      ventureId,
    },
  );

  return data;
};
